import { Suspense, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { changeBodyAttribute } from 'utils';
import { useAppSelector } from 'redux/hooks';

const loading = () => <div className=""></div>;

type DefaultLayoutProps = {};

const DefaultLayout = (props: DefaultLayoutProps) => {
    const { layoutColor } = useAppSelector((state) => ({
        layoutColor: state.Layout.layoutColor,
    }));

    useEffect(() => {
        changeBodyAttribute('data-layout-color', layoutColor);
    }, [layoutColor]);

    return (
        <Suspense fallback={loading()}>
            <Outlet />
        </Suspense>
    );
};
export default DefaultLayout;
